module.exports = __webpack_public_path__ + "img/wizard-02.752d8870.png";